module.exports = __webpack_public_path__ + "static/media/single-bus-about-us.b5e74d67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/tepual/icons/single-bus-about-us.jpg
// module id = 1799
// module chunks = 0